import { cn } from '@/lib/utils.js';

interface WidgetSkeletonProps {
  className?: string | undefined;
}

// H-6: The outer card wrapper was removed — the parent WidgetTile body already provides
// the card frame. This component renders only the inner shimmer/pulse blocks.
export function WidgetSkeleton({ className }: WidgetSkeletonProps) {
  return (
    <div
      className={cn('w-full', className)}
      aria-busy="true"
      aria-label="Loading widget"
      data-testid="widget-skeleton"
    >
      {/* Title placeholder */}
      <div className="mb-4 h-4 w-1/3 animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
      {/* Content placeholders */}
      <div className="space-y-2">
        <div className="h-3 w-full animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
        <div className="h-3 w-5/6 animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
        <div className="h-3 w-4/6 animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
      </div>
      {/* KPI/chart body placeholder */}
      <div className="mt-6 h-20 w-full animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
    </div>
  );
}
